import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import EventIcon from 'components/material-symbol/icons/Event'
import { makeStyles } from '@material-ui/core/styles'
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers'
import CustomLuxonAdapter from 'lib/CustomLuxonAdapter'

const useStyles = makeStyles(theme => ({
  jumpButton: {
    fontWeight: 600,
    fontSize: '0.875rem',
    textTransform: 'none',
    color: theme.palette.text.primary,
    minWidth: 140,
    padding: theme.spacing(0.25, 1),
  },
}))

const hiddenPickerStyle = { display: 'none' }

/**
 * Clickable week/day label that opens a date picker to jump the schedule.
 */
function AcademyScheduleDateJump({ label, value, onJump }) {
  const classes = useStyles()
  const [pickerOpen, setPickerOpen] = useState(false)

  const handleAccept = picked => {
    if (picked?.isValid) {
      onJump(picked)
    }
    setPickerOpen(false)
  }

  if (!label) return null

  return (
    <>
      <Button
        className={classes.jumpButton}
        startIcon={<EventIcon fontSize="small" />}
        onClick={() => setPickerOpen(true)}
        aria-label="Jump to date"
      >
        {label}
      </Button>
      <div style={hiddenPickerStyle} aria-hidden>
        <LocalizationProvider dateAdapter={CustomLuxonAdapter} locale="en-us">
          <MobileDatePicker
            open={pickerOpen}
            value={value}
            onClose={() => setPickerOpen(false)}
            onAccept={handleAccept}
            format="MMM d, yyyy"
          />
        </LocalizationProvider>
      </div>
    </>
  )
}

AcademyScheduleDateJump.propTypes = {
  label: PropTypes.string,
  value: PropTypes.object.isRequired,
  onJump: PropTypes.func.isRequired,
}

export default AcademyScheduleDateJump
